module.exports = __webpack_public_path__ + "img/index-background.5c19f0d4.jpg";